import { styled } from '@clickcease/cc-client-components-lib'

export const DomainSelectionContainer = styled('section', {
  width: '100%',
  height: '300px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  paddingBlock: '$2',
  '-webkit-mask': 'linear-gradient(0deg,#0000,#000 10% 95%,#0000)',
})

export const IdsSelectionRow = styled('div', {
  width: 'calc(100% - 20px)',
  display: 'flex',
  alignItems: 'center',
  padding: '$6 $5',
  borderBottom: '1px solid $lightNeutral',

  '> :nth-child(1)': {
    flex: '1',
  },
  '> :nth-child(2)': {
    flex: '1',
  },

  variants: {
    header: {
      true: {
        borderBottom: '1px solid $neutral',
        padding: '$4 $5',
      },
    },
  },
})
